import { render, staticRenderFns } from "./Chunkword.vue?vue&type=template&id=1380175e"
import script from "./Chunkword.vue?vue&type=script&lang=js"
export * from "./Chunkword.vue?vue&type=script&lang=js"
import style0 from "./Chunkword.vue?vue&type=style&index=0&id=1380175e&prod&%40scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports